import { mapActions, mapGetters } from 'vuex';

export default {
  mounted() {
    this.$store.dispatch('hubspot/setup');
    this.$store.dispatch('intercom/setup');
  },
  computed: {
    ...mapGetters('hubspot', ['isHubSpotReady']),
    ...mapGetters('intercom', ['isIntercomReady']),
    isIntercomEnabled() {
      return this.$statsig.ready && this.$statsig.checkGate('chat_provider_intercom');
    },
    isSupportChatReady() {
      if (this.isIntercomEnabled) {
        return this.isIntercomReady;
      }

      return this.isHubSpotReady;
    },
  },

  watch: {
    isSupportChatReady(value) {
      if (value && window.__VETSTER?.opensSupportChatOnLoad) {
        this.openSupportChat();
      }
    },
  },
  methods: {
    ...mapActions('hubspot', ['openHubSpot']),
    ...mapActions('intercom', ['openIntercom']),

    openSupportChat() {
      if (this.isIntercomEnabled) {
        return this.openIntercom();
      }

      return this.openHubSpot();
    },
  },
};
